import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UserManagementTable from '../components/UserManagementTable';
import InvoiceLimitBanner from '../components/InvoiceLimitBanner';
import { UserContext } from '../context/UserContext';
import { Role } from '@redpanda/types';
import { Button } from '@redpanda/ui';
import { isSubscriptionEnabled } from '../utils/environment';

const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  const userRole = userContext?.user?.role;
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole !== Role.SUPER_ADMIN) {
      navigate('/');
    }
  }, [userRole, navigate]);

  if (userRole !== Role.SUPER_ADMIN) {
    return null;
  }

  return (
    <div className="container mx-auto px-10 py-6 pb-32">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">{t('admin.title')}</h1>

      {/* 發票限制橫幅 - 管理員頁面始終顯示 */}
      <InvoiceLimitBanner
        showAlways={true}
      />

      {userRole === Role.SUPER_ADMIN && (
        <div className="mb-12">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">{t('admin.userManagement')}</h2>
          <UserManagementTable />
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">{t('admin.dataManagementTitle')}</h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t('admin.dataManagementDescription')}
          </p>
          <Button
            onClick={() => navigate('/data-io')}
            className="bg-brand-600 hover:bg-brand-700"
          >
            {t('admin.goToDataIO')}
          </Button>
        </div>

        {/* Subscription Management Section - Only show for non-Docker versions */}
        {isSubscriptionEnabled() && (
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">{t('admin.subscriptionManagement')}</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              {t('admin.subscriptionDescription')}
            </p>
            <a
              href={`${process.env.REACT_APP_ACCOUNT_PORTAL_URL || 'http://localhost:8003'}/accounting`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-200"
            >
              {t('common.navigation.manageSubscription')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;